






































import Vue from 'vue'
import {
  ContentPlaceholders,
  ContentPlaceholdersImg,
} from 'vue-content-placeholders'

export default Vue.extend({
  components: { ContentPlaceholders, ContentPlaceholdersImg },

  props: {
    viewType: {
      type: String,
      default: 'grid',
    },
  },
})
